import { t } from 'i18next';
import { truckGroupEnum, truckModeEnum, truckPriceTypeEnum, truckRenterPriceTypeEnum } from '../enums';

export const truckModeEnumLabels: Record<number, string> = {
    [truckModeEnum.APPRO]: 'appro',
    [truckModeEnum.EVAC]: 'evac',
    [truckModeEnum.TRANSFER]: 'transfer',
    [truckModeEnum.ONSITE]: 'onsite',
    [truckModeEnum.ENLEVEMENT]: 'enlevement',
    [truckModeEnum.POSE]: 'pose',
    [truckModeEnum.ROTATION]: 'rotation',
    [truckModeEnum.DOUBLEFRET]: 'doubleFret',
    [truckModeEnum.BACKANDFORTH]: 'backAndForth',
};

export const truckModeEnumIcons: Record<number, { family: string; name: string }> = {
    [truckModeEnum.APPRO]: { family: 'MaterialCommunityIcons', name: 'arrow-down-right-bold' },
    [truckModeEnum.EVAC]: { family: 'MaterialCommunityIcons', name: 'arrow-right-top-bold' },
    [truckModeEnum.TRANSFER]: { family: 'MaterialCommunityIcons', name: 'transfer-right' },
    [truckModeEnum.ONSITE]: { family: 'FontAwesome6', name: 'arrows-spin' },
    [truckModeEnum.POSE]: { family: 'MaterialCommunityIcons', name: 'arrow-expand-down' },
    [truckModeEnum.ENLEVEMENT]: { family: 'MaterialCommunityIcons', name: 'arrow-expand-up' },
    [truckModeEnum.ROTATION]: { family: 'FontAwesome6', name: 'arrow-down-up-across-line' },
    [truckModeEnum.DOUBLEFRET]: { family: 'FontAwesome', name: 'exchange' },
    [truckModeEnum.BACKANDFORTH]: { family: 'MaterialCommunityIcons', name: 'arrow-u-left-bottom-bold' },
};

export const truckPriceTypeLabels: Record<number, string> = {
    [truckPriceTypeEnum.DAY]: 'day',
    [truckPriceTypeEnum.UNIT]: 'ride',
};

export const truckRenterPriceTypeLabels: Record<number, string> = {
    [truckRenterPriceTypeEnum.DAY]: 'day',
    [truckRenterPriceTypeEnum.UNIT]: 'ride',
    [truckRenterPriceTypeEnum.TON]: 'ton',
};

export const truckGroupLabels: Record<number, string> = {
    [truckGroupEnum.AMPLIROLL]: 'ampliroll',
    [truckGroupEnum.SEMIE]: 'semie',
    [truckGroupEnum.TRUCK_8X4]: '8x4',
};

export const getTruckModeLabel = (mode?: number): string => {
    return mode !== undefined && truckModeEnumLabels[mode] ? t(truckModeEnumLabels[mode]) : '';
};

export const getTruckModeIcon = (mode: number) => {
    return truckModeEnumIcons[mode] ?? { family: '', name: '' };
};

export const getTruckPriceTypeLabel = (mode?: number): string => {
    return mode !== undefined && truckPriceTypeLabels[mode] ? t(truckPriceTypeLabels[mode]) : '';
};

export const getTruckRenterPriceTypeLabel = (mode?: number): string => {
    return mode !== undefined && truckRenterPriceTypeLabels[mode] ? t(truckRenterPriceTypeLabels[mode]) : '';
};

export const getTruckGroupLabel = (group?: number): string => {
    return group !== undefined && truckGroupLabels[group] ? t(truckGroupLabels[group]) : '';
};
